import React from 'react';
import { useFormContext } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Box, Button } from '@chakra-ui/react';

import { useTranslations } from '../../../../contexts/LocalizationContext';
import { CreateNewContactForm } from '../../components/AddNewQuickContact/components/AddNewContactsModal/form/create-new-contact-form';
import { useQuickContactsFilterContext } from '../../context/QuickContactsFilterContext/hooks/useQuickContactsFilterContext';
import { QuickContactType } from '../../model/enums/quick-contact-type.enum';
import { QuickContactRestaurants } from '../QuickContactRestaurants/QuickContactRestaurants';
import { QuickContactUserAddress } from '../QuickContactUserAddress/QuickContactUserAddress';
import { QuickContactUserNickname } from '../QuickContactUserNickname/QuickContactUserNickname';
import { QuickContactUserTypeRadioSelect } from '../QuickContactUserTypeRadioSelect/QuickContactUserTypeRadioSelect';
import { QuickContactModalMode } from './model/enums/QuickContactModalMode';

type AddNewContactsModalBodyProps = {
  onSubmit: (form: CreateNewContactForm) => void;
  isLoading: boolean;
  mode?: QuickContactModalMode;
};

export const AddEditQuickContactModalBody = ({ onSubmit, isLoading, mode }: AddNewContactsModalBodyProps) => {
  const translations = useTranslations();
  const { watch, handleSubmit } = useFormContext<CreateNewContactForm>();
  const { quickContactsState } = useQuickContactsFilterContext();
  const watchType = watch('type');

  const handleFormSubmit = handleSubmit((form) => {
    if (quickContactsState.selectedFnbGroupId) {
      onSubmit(form);
    } else {
      toast.info(translations('quick_contacts_fnb_group_missing_message'));
    }
  });

  return (
    <>
      <form onSubmit={handleFormSubmit}>
        {mode === QuickContactModalMode.EDIT ? null : (
          <Box mb={4}>
            <QuickContactUserTypeRadioSelect />
          </Box>
        )}
        {watchType === QuickContactType.USER ? (
          <Box mb={4}>
            <Box>
              <QuickContactUserNickname />
            </Box>
            <Box>
              <QuickContactUserAddress />
            </Box>
          </Box>
        ) : null}
        {watchType === QuickContactType.RESTAURANT ? (
          <Box mb={4}>
            <QuickContactRestaurants />
          </Box>
        ) : null}
        <Button variant="orangeSolid" type="submit" width="100%" isLoading={isLoading}>
          {translations('quick_contacts_add_new_contact_save_button')}
        </Button>
      </form>
    </>
  );
};
